export default "__VITE_ASSET__DhniNzrc__"